export const MAX_LOAN_AMOUNT = 99999;
export const MIN_LOAN_AMOUNT = 100;
export const DEFAULT_LOAN_AMOUNT = 1000;

export const DEFAULT_WORKING_STATUS = [
	{ key: 'default', value: '', name: '선택해주세요.' },
	{ key: 'hasInsurance', value: 'A', name: '직장인(4대보험O)' },
	{ key: 'NoInsurance', value: 'B', name: '직장인(4대보험X)' },
	{ key: 'indivisualBusiness', value: 'C', name: '개인사업자' },
	{ key: 'coporationBusiness', value: 'D', name: '법인사업자' },
	{ key: 'etc', value: 'E', name: '기타' },
];

export const VALIDATION_DEFAULT_VALUE = {
	name: { invalid: false, msg: '' },
	phone: { invalid: false, msg: '' },
	birth: { invalid: false, msg: '' },
	employmentState: { invalid: false, msg: '' },
	loanAmount: { invalid: false, msg: '' },
	carName: { invalid: false, msg: '' },
};

export const CONSUMER_NAV_LABELS = {
	charter: '헌장',
	organization: '조직도',
	standard: '내부통제기준',
	protection: '보호 기준',
	procedures: '민원처리절차',
	statistics: '민원처리건수',
	portal: '금융감독원 소비자정보 포털',
	inquiry: '금융 상담사 조회',
};
